const DECISIONS = {
  allow: { state: 'approved', status: 'done', label: 'Allowed once' },
  always_allow: { state: 'approved', status: 'done', label: 'Allowed from now on' },
  deny: { state: 'denied', status: 'failed', label: 'Denied' }
};

/** How an answered approval reads: its card state, the execution state shown and the words. Null while unanswered. */
const toApprovalDecision = (decision) => {
  if (decision === true) {
    return DECISIONS.allow;
  }
  if (decision === false) {
    return DECISIONS.deny;
  }
  return DECISIONS[decision] || null;
};

export default toApprovalDecision;
